<template>
  <div class="row">
    <div class="col-md-4 reports-tab-container">
      <div class="row">
        <div class="col-md-8">
          <label class="report-label">{{
            $t("data_exports.invoices.date_range")
          }}</label>
          <base-select
            v-model="selectedRange"
            :options="dateRange"
            :allow-empty="false"
            :show-labels="false"
            @input="onChangeDateRange"
          />
          <span
            v-if="$v.range.$error && !$v.range.required"
            class="text-danger"
          >
            {{ $t("validation.required") }}
          </span>
        </div>
      </div>
      <div class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{
            $t("data_exports.invoices.from_date")
          }}</label>
          <base-date-picker
            v-model="formData.from_date"
            :invalid="$v.formData.from_date.$error"
            :calendar-button="true"
            calendar-button-icon="calendar"
            @change="$v.formData.from_date.$touch()"
            @input="setRangeToCustom"
          />
          <span
            v-if="
              $v.formData.from_date.$error && !$v.formData.from_date.required
            "
            class="text-danger"
          >
            {{ $t("validation.required") }}
          </span>
        </div>
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{
            $t("data_exports.invoices.to_date")
          }}</label>
          <base-date-picker
            v-model="formData.to_date"
            :invalid="$v.formData.to_date.$error"
            :calendar-button="true"
            calendar-button-icon="calendar"
            @change="$v.formData.to_date.$touch()"
            @input="setRangeToCustom"
          />
          <span
            v-if="$v.formData.to_date.$error && !$v.formData.to_date.required"
            class="text-danger"
          >
            {{ $t("validation.required") }}
          </span>
        </div>
      </div>
      <div class="  row report-fields-container">
        <div class="col-md-12">
          <div class="form-check">
            <input
              id="selectallSupplier"
              ref="hideCustomer"
              class="form-check-input"
              type="checkbox"
              @click="hideCustomer"
            >
            <label class="form-check-label" for="selectallSupplier">
              Select All
              <span v-if="userType == 'supplier' || userType == 'funder'">
                {{ $tc("customers.customer", 1) }}
              </span>
              <span v-if="userType == 'anchor'">{{
                $t("invoices.supplier", 1)
              }}</span>
            </label>
          </div>
        </div>
      </div>
      <div
        v-if="userType == 'supplier' || userType == 'funder'"
        :class="hidefields"
        class=" disabled row report-fields-container"
      >
        <div class="col-md-12 report-field-container">
          <label class="form-label">{{ $tc("customers.customer", 1) }} </label>
          <base-customer-select
            ref="customerSelect"
            @select="onSelectCustomer"
            @deselect="clearCustomerSearch"
          />
        </div>
      </div>
      <div
        v-if="userType == 'anchor'"
        :class="hidefields"
        class="row disabled report-fields-container"
      >
        <div class="col-md-12 report-field-container">
          <label class="form-label">{{ $t("invoices.supplier", 1) }}</label>
          <base-select
            v-model="formData.user"
            :options="suppliers"
            :searchable="true"
            :show-labels="false"
            :allow-empty="true"
            :tabindex="8"
            :placeholder="$t('customers.type_or_click')"
            label="company_name"
            track-by="company_id"
          />
        </div>
      </div>
      <div class="row report-fields-container">
        <div class="col-md-12 mb-3">
          <div class="form-check">
            <input
              id="selectall"
              ref="selectAllCheck"
              class="form-check-input"
              type="checkbox"
              @click="selectAll()"
            >
            <label class="form-check-label" for="selectall">
              Select All
            </label>
          </div>
        </div>
        <div v-for="item in FilterReport" :key="item" class="col-md-4">
          <div class="form-check">
            <input
              v-model="formData.viewcolumns"
              :value="item"
              :id="item"
              class="form-check-input"
              type="checkbox"
            >
            <label
              :for="item"
              class="form-check-label"
              @change="$v.formData.viewcolumns.$touch()"
            >
              {{ item }}
            </label>
          </div>
        </div>
      </div>
      <div class="row report-submit-button-container">
        <div class="col-md-6">
          <base-button
            outline
            color="theme"
            class="report-button"
            @click="getReports()"
          >
            {{ $t("data_exports.update_data") }}
          </base-button>
        </div>
      </div>
    </div>
    <div class="col-sm-8 reports-tab-container">
      <iframe :src="getReportUrl" class="reports-frame-style" />
      <a
        class="base-button btn btn-primary btn-lg report-view-button"
        @click="viewReportsPDF"
      >
        <font-awesome-icon
          icon="file-pdf"
          class="vue-icon icon-left svg-inline--fa fa-download fa-w-16 mr-2"
        />
        <span>{{ $t("data_exports.view_pdf") }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { validationMixin } from 'vuelidate'
const { required } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      hidefields: '',
      reportTypes: ['By Customer', 'By Item'],
      selectedType: 'By Customer',
      tableData: [],
      dateRange: [
        'Today',
        'This Week',
        'This Month',
        'This Quarter',
        'This Year',
        'Previous Week',
        'Previous Month',
        'Previous Quarter',
        'Previous Year',
        'Custom'
      ],
      FilterReport: [
        'Invoice Date',
        'Invoice Due Date',
        'Buyer Name',
        'Supplier Name',
        'Status',
        'System-generated Invoice No.',
        'Amount',
        'Promised Payment Date',
        'Offer Amount',
        'Prepayment',
        'Supplier Contact No.',
        'Supplier Address',
        'Supplier National Tax Registration Number',
        'Invoice Reference No.',
        'System-generated DN',
        'Delivery Note Date',
        'National Tax Registration Number',
        'Sales Tax Registration Number',
        'System-generated PO',
        'Payment Term',
        'Purchase Order Date',
        'PO Reference Number',
        'Delivery Note Information',
        'Billing Address',
        'Shipping Address',
        'Notes',
        'Vendor Number',
        'Tax Amount',
        'Discrepancy',
        'Payment Amount',
        'Actual Amount',
        'Check Number',
        'Date of Prepayment',
        'Received Invoice Date'
      ],
      columnMapping: {
        invoiceDate: 'Invoice Date',
        invoiceDueDate: 'Invoice Due Date',
        buyerName: 'Buyer Name',
        supplierName: 'Supplier Name',
        status: 'Status',
        systemGeneratedInvoiceNo: 'System-generated Invoice No.',
        amount: 'Amount',
        promisedPaymentDate: 'Promised Payment Date',
        offerAmount: 'Offer Amount',
        prePaymentStatus: 'Prepayment',
        supplierContactNo: 'Supplier Contact No.',
        supplierAddress: 'Supplier Address',
        supplierNationalTaxRegistration:
          'Supplier National Tax Registration Number',
        referenceNumber: 'Invoice Reference No.',
        systemGenerateDN: 'System-generated DN',
        deliveryNoteDate: 'Delivery Note Date',
        buyerNationalTaxRegistration: 'National Tax Registration Number',
        salesRegistrationTax: 'Sales Tax Registration Number',
        systemGeneratedPO: 'System-generated PO',
        paymentTerm: 'Payment Term',
        purchaseOrderDate: 'Purchase Order Date',
        poReferenceNumber: 'PO Reference Number',
        deliveryNoteInformation: 'Delivery Note Information',
        billingAddress: 'Billing Address',
        shippingAddress: 'Shipping Address',
        notes: 'Notes',
        vendorNumber: 'Vendor Number',
        taxAmount: 'Tax Amount',
        discrepancy: 'Discrepancy',
        paymentAmount: 'Payment Amount',
        actualAmount: 'Actual Amount',
        checkNumber: 'Check Number',
        prePaymentDate: 'Date of Prepayment',
        receivedInvoiceDate: 'Received Invoice Date'
      },
      selectedRange: 'This Month',
      range: new Date(),
      formData: {
        from_date: moment()
          .startOf('month')
          .toString(),
        to_date: moment()
          .endOf('month')
          .toString(),
        customer_id: '',
        user: '',
        viewcolumns: [
          'Invoice Date',
          'Invoice Due Date',
          'Buyer Name',
          'Supplier Name',
          'Status',
          'System-generated Invoice No.',
          'Amount',
          'Promised Payment Date',
          'Offer Amount',
          'Prepayment'
        ]
      },
      url: null,
      customerSiteURL: null,
      userType: null
    }
  },
  validations: {
    range: {
      required
    },
    formData: {
      from_date: {
        required
      },
      to_date: {
        required
      }
    }
  },
  computed: {
    ...mapGetters('company', ['getSelectedCompany']),

    ...mapGetters('supplier', ['suppliers']),
    getReportUrl () {
      return this.url
    }
  },
  watch: {
    range (newRange) {
      this.formData.from_date = moment(newRange)
        .startOf('year')
        .toString()
      this.formData.to_date = moment(newRange)
        .endOf('year')
        .toString()
    }
  },
  created () {
    let data = { pagination: 'no' }
    if (localStorage.getItem('role') === 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') === 'anchor') {
      this.userType = 'anchor'
      this.fetchSuppliers(data)
    } else if (localStorage.getItem('account_type') === 'funder') {
      this.userType = 'funder'
    } else if (localStorage.getItem('account_type') === 'supplier') {
      this.userType = 'supplier'
    }
  },
  mounted () {
    this.customerSiteURL = `/data-exports/invoices-detail/customer/${
      this.getSelectedCompany.unique_hash
    }`

    this.getInitialReport()
  },
  methods: {
    ...mapActions('supplier', ['fetchSuppliers']),
    ...mapActions('invoice', ['fetchDownloadInvoiceDetail']),

    formatDate (dateString, format = 'dd-MM-yyyy') {
      if (!dateString) return null
      const date = new Date(dateString)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      return format
        .replace(/dd/g, day)
        .replace(/MM/g, month)
        .replace(/yyyy/g, year)
        .replace(/yy/g, String(year).slice(-2))
    },
    async loadExcelSheetData () {
      let payload = {
        hash: this.getSelectedCompany.unique_hash,
        from_date: moment(this.formData.from_date).format('DD/MM/YYYY'),
        to_date: moment(this.formData.to_date).format('DD/MM/YYYY')
      }
      let res = await this.fetchDownloadInvoiceDetail(payload)

      if (res.data.invoices.length > 0) {
        const formattedResponse = res.data.invoices.map(invoice => {
          return {
            invoiceDate: invoice.invoice_date
              ? this.formatDate(invoice.invoice_date, 'dd-MM-yyyy')
              : null,
            invoiceDueDate: invoice.due_date
              ? this.formatDate(invoice.due_date, 'dd-MM-yyyy')
              : null,
            buyerName: invoice.buyer_name,
            supplierName: invoice.supplier_name,
            status:
          this.userType === 'anchor' && invoice && invoice.status === 'SENT'
            ? 'RECEIVED'
            : invoice
              ? invoice.status
              : '',
            systemGeneratedInvoiceNo: invoice.invoice_number,
            amount: invoice.amount,
            promisedPaymentDate: invoice.promised_payment_date
              ? this.formatDate(invoice.promised_payment_date, 'dd-MM-yyyy')
              : null,
            offerAmount: invoice.offer_amount,
            prePaymentStatus: invoice.pre_payment_status,
            supplierContactNo: invoice.supplier_contact_number,
            supplierAddress: invoice.supplier_address,
            supplierNationalTaxRegistration:
          invoice.supplier_national_tax_registration,
            referenceNumber: invoice.invoice_reference_number,
            systemGenerateDN: invoice.system_generate_dn,
            deliveryNoteDate: invoice.delivery_note_date
              ? this.formatDate(invoice.delivery_note_date, 'dd-MM-yyyy')
              : null,
            buyerNationalTaxRegistration:
          invoice.buyer_national_tax_registration,
            salesRegistrationTax: invoice.sales_registration_tax,
            systemGeneratedPO: invoice.system_generated_po,
            paymentTerm: invoice.payment_term,
            purchaseOrderDate: invoice.purchase_order_date
              ? this.formatDate(invoice.purchase_order_date, 'dd-MM-yyyy')
              : null,
            poReferenceNumber: invoice.po_reference_number,
            deliveryNoteInformation: invoice.delivery_note_information,
            billingAddress: invoice.billing_address,
            shippingAddress: invoice.shipping_address,
            notes: invoice.notes,
            vendorNumber: invoice.vendor_number,
            taxAmount: invoice.tax_amount,
            discrepancy: invoice.due_amount,
            paymentAmount: invoice.payment_amount,
            actualAmount: invoice.actual_amount,
            checkNumber: invoice.check_number,
            prePaymentDate: invoice.pre_payment_date
              ? this.formatDate(invoice.pre_payment_date, 'dd-MM-yyyy')
              : null,
            receivedInvoiceDate: invoice.received_invoice_date
              ? this.formatDate(invoice.received_invoice_date, 'dd-MM-yyyy')
              : null
          }
        })

        const selectedColumns = this.formData.viewcolumns || []
        const finalResponse = formattedResponse.map(invoice =>
          Object.fromEntries(
            Object.entries(invoice).filter(([key]) =>
              selectedColumns.includes(this.columnMapping[key])
            )
          )
        )
        this.tableData = finalResponse

        const selectedKeys = Object.keys(this.columnMapping).filter(key =>
          this.formData.viewcolumns.includes(this.columnMapping[key])
        )

        const formattedTableData = this.tableData.map(
          item => selectedKeys.map(key => item[key] || '')
        )

        const worksheetData = [this.formData.viewcolumns, ...formattedTableData]
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        })
        const data = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })

        saveAs(data, `Data.xlsx`)
      }
    },
    getThisDate (type, time) {
      return moment()
        [type](time)
        .toString()
    },
    getPreDate (type, time) {
      return moment()
        .subtract(1, time)
        [type](time)
        .toString()
    },
    selectAll () {
      if (this.$refs.selectAllCheck.checked) {
        this.formData.viewcolumns = [
          'Invoice Date',
          'Invoice Due Date',
          'Buyer Name',
          'Supplier Name',
          'Status',
          'System-generated Invoice No.',
          'Amount',
          'Promised Payment Date',
          'Offer Amount',
          'Prepayment',
          'Supplier Contact No.',
          'Supplier Address',
          'Supplier National Tax Registration Number',
          'Invoice Reference No.',
          'System-generated DN',
          'Delivery Note Date',
          'National Tax Registration Number',
          'Sales Tax Registration Number',
          'System-generated PO',
          'Payment Term',
          'Purchase Order Date',
          'PO Reference Number',
          'Delivery Note Information',
          'Billing Address',
          'Shipping Address',
          'Notes',
          'Vendor Number',
          'Tax Amount',
          'Discrepancy',
          'Payment Amount',
          'Actual Amount',
          'Check Number',
          'Date of Prepayment',
          'Received Invoice Date'
        ]
      } else {
        this.formData.viewcolumns = []
      }
    },
    hideCustomer () {
      if (this.$refs.hideCustomer.checked) {
        this.hidefields = 'd-none'
        this.formData.customer_id = ''
      } else {
        this.hidefields = ''
        this.formData.customer_id = ''
      }
    },
    onChangeDateRange () {
      switch (this.selectedRange) {
        case 'Today':
          this.formData.from_date = moment().toString()
          this.formData.to_date = moment().toString()
          break

        case 'This Week':
          this.formData.from_date = this.getThisDate('startOf', 'isoWeek')
          this.formData.to_date = this.getThisDate('endOf', 'isoWeek')
          break

        case 'This Month':
          this.formData.from_date = this.getThisDate('startOf', 'month')
          this.formData.to_date = this.getThisDate('endOf', 'month')
          break

        case 'This Quarter':
          this.formData.from_date = this.getThisDate('startOf', 'quarter')
          this.formData.to_date = this.getThisDate('endOf', 'quarter')
          break

        case 'This Year':
          this.formData.from_date = this.getThisDate('startOf', 'year')
          this.formData.to_date = this.getThisDate('endOf', 'year')
          break

        case 'Previous Week':
          this.formData.from_date = this.getPreDate('startOf', 'isoWeek')
          this.formData.to_date = this.getPreDate('endOf', 'isoWeek')
          break

        case 'Previous Month':
          this.formData.from_date = this.getPreDate('startOf', 'month')
          this.formData.to_date = this.getPreDate('endOf', 'month')
          break

        case 'Previous Quarter':
          this.formData.from_date = this.getPreDate('startOf', 'quarter')
          this.formData.to_date = this.getPreDate('endOf', 'quarter')
          break

        case 'Previous Year':
          this.formData.from_date = this.getPreDate('startOf', 'year')
          this.formData.to_date = this.getPreDate('endOf', 'year')
          break

        default:
          break
      }
    },
    setRangeToCustom () {
      this.selectedRange = 'Custom'
    },
    async getInitialReport () {
      if (this.selectedType === 'By Customer') {
        if (this.userType === 'supplier') {
          this.url = `${this.customerSiteURL}?customer_id=${
            this.formData.customer_id
          }&columns=${this.formData.viewcolumns}&from_date=${moment(
            this.formData.from_date
          ).format('DD/MM/YYYY')}&to_date=${moment(
            this.formData.to_date
          ).format('DD/MM/YYYY')}`
        } else if (this.userType === 'funder') {
          this.url = `${this.customerSiteURL}?user_id=${
            this.formData.customer_id
          }&columns=${this.formData.viewcolumns}&due_from_date=${moment(
            this.formData.from_date
          ).format('DD/MM/YYYY')}&due_to_date=${moment(
            this.formData.to_date
          ).format('DD/MM/YYYY')}`
        } else if (this.userType === 'anchor') {
          this.url = `${this.customerSiteURL}?company_id=${
            this.formData.user === ''
              ? this.formData.user
              : this.formData.user.company_id
          }&columns=${this.formData.viewcolumns}&from_date=${moment(
            this.formData.from_date
          ).format('DD/MM/YYYY')}&to_date=${moment(
            this.formData.to_date
          ).format('DD/MM/YYYY')}`
        }

        return true
      }
      return true
    },
    async viewReportsPDF () {
      let data = await this.getReports()
      window.open(this.getReportUrl, '_blank')
      return data
    },
    async getReports (isDownload = false) {
      this.$v.range.$touch()
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }

      await this.filterColumns()
      if (this.selectedType === 'By Customer') {
        if (this.userType === 'supplier') {
          this.url = `${this.customerSiteURL}?customer_id=${
            this.formData.customer_id
          }&columns=${this.formData.viewcolumns}&from_date=${moment(
            this.formData.from_date
          ).format('DD/MM/YYYY')}&to_date=${moment(
            this.formData.to_date
          ).format('DD/MM/YYYY')}`
        } else if (this.userType === 'funder') {
          this.url = `${this.customerSiteURL}?user_id=${
            this.formData.customer_id
          }&columns=${this.formData.viewcolumns}&due_from_date=${moment(
            this.formData.from_date
          ).format('DD/MM/YYYY')}&due_to_date=${moment(
            this.formData.to_date
          ).format('DD/MM/YYYY')}`
        } else if (this.userType === 'anchor') {
          this.url = `${this.customerSiteURL}?company_id=${
            this.formData.user === ''
              ? this.formData.user
              : this.formData.user.company_id
          }&columns=${this.formData.viewcolumns}&from_date=${moment(
            this.formData.from_date
          ).format('DD/MM/YYYY')}&to_date=${moment(
            this.formData.to_date
          ).format('DD/MM/YYYY')}`
        }
        return true
      }

      return true
    },
    async downloadReport () {
      this.loadExcelSheetData()
      // if (!this.getReports()) {
      //   return false;
      // }
      // await this.filterColumns();
      // window.open(this.getReportUrl + "&download=true");
      // setTimeout(() => {
      //   if (this.selectedType === "By Customer") {
      //     if (this.userType === "supplier") {
      //       this.url = `${this.customerSiteURL}?customer_id=${
      //         this.formData.customer_id
      //       }&columns=${this.formData.viewcolumns}&from_date=${moment(
      //         this.formData.from_date
      //       ).format("DD/MM/YYYY")}&to_date=${moment(
      //         this.formData.to_date
      //       ).format("DD/MM/YYYY")}`;
      //     } else if (this.userType === "funder") {
      //       this.url = `${this.customerSiteURL}?user_id=${
      //         this.formData.customer_id
      //       }&columns=${this.formData.viewcolumns}&due_from_date=${moment(
      //         this.formData.from_date
      //       ).format("DD/MM/YYYY")}&due_to_date=${moment(
      //         this.formData.to_date
      //       ).format("DD/MM/YYYY")}`;
      //     } else if (this.userType === "anchor") {
      //       this.url = `${this.customerSiteURL}?user_id=${
      //         this.formData.user === ""
      //           ? this.formData.user
      //           : this.formData.user.company_id
      //       }&columns=${this.formData.viewcolumns}&from_date=${moment(
      //         this.formData.from_date
      //       ).format("DD/MM/YYYY")}&to_date=${moment(
      //         this.formData.to_date
      //       ).format("DD/MM/YYYY")}`;
      //     }
      //   }
      //   return true;
      // }, 200);
    },
    filterColumns () {
      var result = []
      var selectedColumns = this.formData.viewcolumns
      this.formData.viewcolumns = this.FilterReport.filter(item =>
        selectedColumns.includes(item)
      )
    },
    onSelectCustomer (customer) {
      this.formData.customer_id = customer.id
    },
    async clearCustomerSearch (removedOption, id) {
      this.formData.customer_id = ''
    }
  }
}
</script>
